import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { COMPANY } from "@/data/content";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    intro: `${COMPANY.name} respects your privacy. This policy explains how we collect and use the information you share with us.`,
    sections: [
      { h: "Information we collect", p: "When you submit an enquiry or contact form, we collect your name, phone number, email and message so our team can respond to your request." },
      { h: "How we use it", p: "Your details are used solely to respond to enquiries, provide quotes, arrange demonstrations and offer after-sales support. We do not sell your data." },
      { h: "Data security", p: "We take reasonable measures to protect your information. Enquiries are stored securely and accessed only by authorized ADK SOLUTIONS staff." },
      { h: "Contact", p: `For any privacy questions, email us at ${COMPANY.email}.` },
    ],
  },
  terms: {
    title: "Terms & Conditions",
    intro: `By using the ${COMPANY.name} website, you agree to the following terms.`,
    sections: [
      { h: "Product information", p: "Product specifications, images and recommended tractor HP are indicative. Actual specifications are confirmed at the time of purchase." },
      { h: "Enquiries & quotes", p: "Quotes shared in response to enquiries are estimates and subject to change based on availability, configuration and prevailing prices." },
      { h: "Warranty", p: "Warranty coverage is provided by the manufacturer and varies by product. Terms are shared at the time of sale." },
      { h: "Liability", p: "ADK SOLUTIONS is not liable for indirect losses arising from use of machinery. Always follow manufacturer operating guidelines." },
    ],
  },
};

export default function Legal({ type = "privacy" }) {
  useEffect(() => { window.scrollTo(0, 0); }, [type]);
  const data = CONTENT[type] || CONTENT.privacy;

  return (
    <main data-testid={`legal-${type}`} className="bg-brand-cream pt-28 pb-24 min-h-screen">
      <div className="mx-auto max-w-3xl px-5 lg:px-8">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-brand-ink/60 hover:text-brand-green transition-colors mb-8">
          <ArrowLeft className="size-4" /> Home
        </Link>
        <h1 className="font-heading font-extrabold text-brand-ink tracking-tighter text-4xl sm:text-5xl">{data.title}</h1>
        <p className="mt-5 text-brand-ink/70 leading-relaxed text-lg">{data.intro}</p>
        <div className="mt-10 space-y-8">
          {data.sections.map((s) => (
            <section key={s.h}>
              <h2 className="font-heading font-bold text-xl text-brand-ink mb-2">{s.h}</h2>
              <p className="text-brand-ink/70 leading-relaxed">{s.p}</p>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
